/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ReloadInputs */



/**
* | output |
* | --- |
* | "Reload" |
*
* @param {Common_ReloadInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const common_reload = /** @type {((inputs?: Common_ReloadInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ReloadInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neu laden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recharger")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("重新加载")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("重新載入")
	if (locale === "ko") return /** @type {LocalizedString} */ ("새로고침")
	return /** @type {LocalizedString} */ ("Reload")
});